import { render, staticRenderFns } from "./HMProductTag.vue?vue&type=template&id=3956cf5b&scoped=true&"
import script from "./HMProductTag.vue?vue&type=script&lang=js&"
export * from "./HMProductTag.vue?vue&type=script&lang=js&"
import style0 from "./HMProductTag.vue?vue&type=style&index=0&id=3956cf5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956cf5b",
  null
  
)

export default component.exports